import axios from 'axios';
import log from 'chameleon/ui-stack/utilities/log';

/**
 * @param {string} app Name of the app that is being logged.
 * @param {string} eventType Type of event.
 * @param {string} location Url of the event.
 * @param {object} options Options to be logged as part of params.
 * @return {Object.<Promise>}
 */
export default function trackerLog(app, eventType, location, options) {
  const optionsObj = options || {};
  const environment = process.env.ENV;
  let env = environment;

  if (env === 'dev') {
    env = 'development';
  } else if (env === 'prod') {
    env = 'production';
  }

  const data = {
    ...optionsObj,
    app,
    params: { object: location },
    event_type: eventType,
    v: 1,
    env,
  };

  /**
   * If the request fails and catch() is invoked, capture the exception and return
   * a resolved promise to continue the promise chain (if applicable).
   */
  return axios({
    url: `${FYM_TELEMETRY_BACKEND_URL}`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data,
  }).catch((error) => {
    log('error', error);

    return Promise.resolve(true);
  });
}
